export default [
  {
    name: 'HOME',
    url: '/',
    icon: 'mdi-home-outline'
  },
  {
    name: 'ABOUT',
    url: '/about',
    icon: 'mdi-information-outline'
  },
  {
    name: 'Vuetify',
    url: '/vuetify',
    icon: 'mdi-vuejs'
  },
  {
    name: '404',
    url: '/hf8wehegiaohiedwhie',
    icon: 'mdi-help-circle-outline'
  }
]
